import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';

const currencySymbols = {
  AUD: '$',
  CAD: '$',
  CHF: 'CHF',
  CZK: 'Kč',
  DKK: 'kr.',
  EUR: '€',
  GBP: '£',
  HUF: 'Ft',
  NOK: 'kr.',
  PLN: 'PLN',
  SEK: 'kr.',
  USD: '$',
};

export type Currency = keyof typeof currencySymbols;

const currencies = Object.keys(currencySymbols) as Currency[];

const useCurrencies = () => {
  const { t } = useTranslation('common');

  return useMemo(
    () => ({
      currencies: sortBy(currencies, (currency) => t(`currencies.${currency}`).toLowerCase()),
      getCurrencySymbol: (currency: string) => (
        Object.keys(currencySymbols).includes(currency) ? currencySymbols[currency as Currency] : currency
      ),
    }),
    [t],
  );
};

export default useCurrencies;
